<template>
	<el-select
		:class="[
			'select-component',
			'w-100',
			{ 'select-component-second': secondStyle },
		]"
		v-bind="$attrs"
		:value="value"
		:disabled="disabled"
		@input="sendValue"
	>
		<el-option
			v-for="item in optionsComputed"
			:key="item.value"
			:label="item.itemText"
			:value="item.itemValue"
		>
		</el-option>
	</el-select>
</template>
<script>
import lib from '@/helpers/lib';

const { compose, setNewProperty } = lib;

function sendValue(val) {
	this.$emit('input', val);
}

function optionsComputed() {
	const self = this;
	return this.options.reduce((list, item) => {
		const label = item[self.itemText] || item;
		const val = item[self.itemValue] || item;
		return list.concat(
			compose(
				setNewProperty('itemText', label),
				setNewProperty('itemValue', val),
			)(item),
		);
	}, []);
}

export default {
	name: 'select-component',
	computed: {
		optionsComputed,
	},
	inheritAttrs: false,
	methods: {
		sendValue,
	},
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		itemText: {
			default: '',
			type: String,
		},
		itemValue: {
			default: '',
			type: String,
		},
		options: {
			default: () => [],
			type: Array,
		},
		secondStyle: {
			default: false,
			type: Boolean,
		},
		value: null,
	},
};
</script>



// WEBPACK FOOTER //
// selectComponent.vue?13027bcc